"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepSelectFlight = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const FlightsOnWeekTabs_1 = require("../FlightsOnWeekTabs");
const StepSelectFlight = (props) => {
    const { flightDirection, ...restProps } = props;
    const textProps = {
        outbound: {
            reservationFlightTitle: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/SelectFlight:OutboundFlight', defaultMessage: 'Outbound flight' })),
            submitButtonText: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/SelectFlight:ConfirmOutboundFlight', defaultMessage: 'Confirm outbound flight' })),
        },
        ['return']: {
            reservationFlightTitle: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/SelectFlight:ReturnFlight', defaultMessage: 'Return flight' })),
            submitButtonText: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/SelectFlight:ConfirmReturnFlight', defaultMessage: 'Confirm return flight' })),
        },
    };
    const flightsOnWeekTabsProps = {
        ...restProps,
        ...textProps[flightDirection],
    };
    return react_1.default.createElement(FlightsOnWeekTabs_1.FlightsOnWeekTabs, { ...flightsOnWeekTabsProps });
};
exports.StepSelectFlight = StepSelectFlight;
//# sourceMappingURL=index.js.map